// Auth state is managed by Better Auth (cookie sessions via authClient.useSession()).
// This store only holds transient UI state.
import { create } from 'zustand';

interface AuthUIState {
  magicLinkSent: boolean;
  magicLinkEmail: string;
  setMagicLinkSent: (sent: boolean, email?: string) => void;
  reset: () => void;
}

export const useAuthUIStore = create<AuthUIState>((set) => ({
  magicLinkSent: false,
  magicLinkEmail: '',
  setMagicLinkSent: (sent, email = '') => set({ magicLinkSent: sent, magicLinkEmail: email }),
  reset: () => set({ magicLinkSent: false, magicLinkEmail: '' }),
}));
